import React from 'react';
import './loader.css';

function Error(props) {
	return (
		<div className="Error">
			<div className="Error--Text">SOMETHING WENT WRONG!</div>
			<div className="Error--Subtext" onClick={() => props.tryAgain()}>
				PLEASE TRY AGAIN LATER...
			</div>

			{/* <div className="ErrorPopUp">An Error Occured</div> */}
		</div>
	);
}

export default Error;
